import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  //FGBottlerSelection REDUX part
  FGbottlerData: [],
  FGtransformedTreeData: [],
  FGselectedTreeIds: [],
  FGfinalTreeData: [],
  FGfilterApplied: false,
};

const FGEntityTree = createSlice({
  name: "FGentity",
  initialState,
  reducers: {
    setFGBottlerData: (state, action) => {
      state.FGbottlerData = action.payload;
    },
    setFGTransformedTreeData: (state, action) => {
      state.FGtransformedTreeData = action.payload;
    },
    setFGSelectedTreeIds: (state, action) => {
      state.FGselectedTreeIds = action.payload;
    },
    setFGFinalTreeData: (state, action) => {
      state.FGfinalTreeData = action.payload;
    },
    setFGFilterApplied: (state, action) => {
      state.FGfilterApplied = action.payload;
    },
  },
});

export const {
  setFGBottlerData,
  setFGTransformedTreeData,
  setFGSelectedTreeIds,
  setFGFinalTreeData,
  setFGFilterApplied,
} = FGEntityTree.actions;
export default FGEntityTree.reducer;
